import React, { useState } from 'react';
import { Select, Label, ValidationMessage, Text } from '@gjensidige/builders-components';
import { useAppSelector } from '../../hooks/appHooks';
import { getProductName } from '../../store/slices/offerSlice';
import { IDropDownProps, IDropDownOptions } from '../../interfaces/EnquiryInterface';
import { Validator } from '../../utils/Validator';
import { HelpText } from './HelpText';
import tracker from '../../tracking.js';

interface InputStatusProps {
  isValid: boolean;
  errorMessage: string;
}

export const EnquiryOptionDropDown: React.FC<IDropDownProps> = (
  props: IDropDownProps
) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(true);
  const productName = useAppSelector(getProductName);
  const handleChange = (selectedOption: any) => {
    const value = selectedOption || '';
    if (!value) {
      return;
    }
    const inputStatus: InputStatusProps = Validator.validate(
      props.questionType,
      value,
      productName
    );

    if (inputStatus.isValid) {
      setErrorMessage('');
    } else {
      setErrorMessage(inputStatus.errorMessage);
    }
    setIsValid(inputStatus.isValid);
    const selectedLabel = props.options?.find((option: IDropDownOptions) => option.value === value)?.label || '';
    /***
      Custom tracking as the builders component version used in the app track the event status with both label and value.
      Fix for https://jira.gjensidige.dev/jira/browse/SE-6254
      TODO: Remove the custom tracking once we migrated to new builders-components, if it supports the desired tracking.
    ***/
    tracker.trackEvent({
      "eventLabel": props.labelText,
      "eventStatus": selectedLabel,
      "eventAction": "onblur",
      "eventCategory": "dropdown",
      "eventKey": "dropdown"
    })
    props.handleChange(props.questionType, value, inputStatus.isValid);
  };
  return (
    <>
      {props.helpText ?
        <HelpText labelText={props.labelText} message={props.helpText} helpTextClassName="enquiry-drop-down-label" referenceId={props.questionType} />
        :
        <Label htmlFor={props.questionType} className="enquiry-drop-down-label">{props.labelText}</Label>
      }
      {props.labelDescription && <Text size="body"> {props.labelDescription} </Text>}
      <Select
        id={props.questionType}
        name={`${props.questionType}-options`}
        onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleChange(event.target.value)}
        // options={props.options}
        value={props.selectedValue}
        invalid={!isValid && !!errorMessage}
        // placeholder={props.placeholderText || 'Välj'}
        wrapperProps={{
          className: `template-drop-down drop-down-section-wrapper ${props.questionType}`
        }}
        //labelClassName="enquiry-group-label"
        tracking={false}
        {...props.ariaDescribedBy ? { 'aria-describedby': props.ariaDescribedBy } : {}}
      >
        <option value="">
          Välj
        </option>
        {
          props.options?.map((option: IDropDownOptions) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))
        }
      </Select>
      {
        !isValid && !!errorMessage &&
        <ValidationMessage
          htmlFor={props.questionType}
        >
          <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
        </ValidationMessage>
      }
    </>
  );
};
